<template>
  <div class="on-demand-dashboard container-fluid p-4">
    <kpi-boxes />
    <demand-chart />
    <efficiency-chart />
    <otp-chart />
    <usage-chart />
  </div>
</template>

<script>
import kpiBoxes from './components/KpiBoxes.vue';
import demandChart from './components/DemandChart.vue';
import usageChart from './components/UsageChart.vue';
import efficiencyChart from './components/EfficiencyChart.vue';
import otpChart from './components/OtpChart.vue';

export default {
  name: 'FlexiOnDemandDashboard',
  components: {
    kpiBoxes,
    demandChart,
    usageChart,
    otpChart,
    efficiencyChart,
  },
};
</script>
<style lang="scss">
.on-demand-dashboard {
  hr {
    border-top: 1px solid #e6eaee;
    opacity: 1;
  }
  .dashboard-graph-tooltip {
    width: 200px;
    .title {
      margin-bottom: 16px;
      font-weight: bold;
    }
    .text-label {
      font-weight: normal;
    }
    .text-value {
      margin-left: 16px;
      font-weight: bold;
    }
  }
}
</style>
